import React, { useState } from "react";
import { config } from "../Test/config";
const Auth = ({ signIn }) => {
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  //   const [user, setUser] = useState(null);

  // const credentials = config.credentials;

  const handleLogin = (e) => {
    e.preventDefault();
    console.log(config);
    if (
      config.credentials[account] &&
      config.credentials[account].password === password
    ) {
      // setIsLoggedIn(true);
      setError("");
      signIn({ account: account, ...config.credentials[account] });
    } else {
      setError("Invalid account or password");
    }
  };

  return (
    <div>
      {
        <form
          onSubmit={handleLogin}
          style={{
            // width: "100vw",
            // height: "100vh", // 確保容器佔滿整個視窗高度
            // margin: "0 auto",
            display: "block",
            justifyContent: "center", // 水平居中
            // alignItems: "center", // 垂直居中
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <label>Account: </label>
            <input
              type="text"
              value={account}
              onChange={(e) => setAccount(e.target.value)}
              style={{
                height: "30px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                padding: "5px",
                marginLeft: "10px",
              }}
            />
          </div>
          <br />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <label>Password: </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                height: "30px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                padding: "5px",
                marginLeft: "10px",
              }}
            />
          </div>
          <br />
          <button type="submit">Log In</button>
          <br />
          {error && <p style={{ color: "red" }}>{error}</p>}
        </form>
      }
    </div>
  );
};

export default Auth;
